import { render, staticRenderFns } from "./AddRestaurants.vue?vue&type=template&id=7822ca0c"
import script from "./AddRestaurants.ts?vue&type=script&lang=ts&external"
export * from "./AddRestaurants.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports